import { useMapEvents } from 'react-leaflet';

type Props = {
  /** 地図の何も無いところが押されたとき */
  onBackgroundClick: () => void;
};

/**
 * MapContainer の子として置く不可視コンポーネント。
 *
 * 詳細パネルが「×」を押すまで残っていたので、地図の背景を押しても閉じられるようにする。
 *
 * Leaflet はマーカー・線・クラスターのクリックで map の click を発火しない
 * (L.DomEvent.stopPropagation が入る) ため、ここで拾えるのは背景のクリックだけ。
 * マーカーを選んだ直後に閉じてしまう心配はない。
 *
 * Why not drag/movestart も拾う: 地図を掴んで動かすのは経路を追う操作で、そのたびに
 * パネルが消えると読めない。閉じるのはクリックのときだけにする。
 */
const MapBackgroundClick = ({ onBackgroundClick }: Props) => {
  useMapEvents({ click: onBackgroundClick });

  return null;
};

export default MapBackgroundClick;
